import * as React from "react";
import { UitkHeading } from "@egds/react-core/text";
import { DestinationCrossLinkProps } from "./typings";
import { DestinationCrossLinkFlexModuleResult } from "typings/microserviceModels/destination-cross-link-flex-module";
import { ViewType } from "./DestinationCrossLinkEnums";
import { getFormatTextLocationKey } from "components/flexComponents/DestinationCrossLink/DestinationCrossLinkUtils";
import CardsView from "components/shared/DestinationCardView/CardsView";
import ListsView from "components/shared/DestinationCardView/ListsView";
import { withStores } from "src/stores";
import { observer } from "mobx-react";
import { UitkSpacing } from "@egds/react-core/spacing";

const DestinationCrossLink = withStores(
  "flexModuleModelStore",
  "context",
  "uriContext"
)(
  observer((props: DestinationCrossLinkProps) => {
    const { templateComponent, flexModuleModelStore } = props;
    const { id } = templateComponent.metadata;
    const model = flexModuleModelStore.getModel(id) as DestinationCrossLinkFlexModuleResult | null;
    const destinations = model?.destinations;

    if (!model || model.empty || !destinations || !destinations.length) {
      return null;
    }

    const { title, view, geoType } = model;

    return (
      <>
        <div className="DestinationCrossLink" id={id} data-testid="DestinationCrossLinkHeading">
          <UitkSpacing margin={{ blockend: "three" }}>
            <UitkHeading tag="h2" size={4}>
              {title}
            </UitkHeading>
          </UitkSpacing>

          {view === ViewType.DETAIL ? (
            <CardsView
              baseKey="cross-link-destination-cards"
              destinations={destinations}
              localiseKey={getFormatTextLocationKey(geoType)}
              moduleName="destinationCrossLink"
            />
          ) : (
            <ListsView
              baseKey="cross-link-destination-links"
              destinations={destinations}
              localiseKey={getFormatTextLocationKey(geoType)}
              moduleName="destinationCrossLink"
            />
          )}
        </div>
      </>
    );
  })
);

export default DestinationCrossLink;
